import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { SidebarPortal, BlockDataForm } from '@plone/volto/components';
import View from './View';
import { IconsListerSchema } from './schema';

// Gli elementi del widget richiedono un '@id' univoco
const toItem = (subblock, index) => ({
  ...subblock,
  '@id': subblock['@id'] ?? subblock.id ?? `subblock-${index}`,
});

const Edit = (props) => {
  const { data, block, selected, onChangeBlock } = props;
  const intl = useIntl();
  const schema = IconsListerSchema({ intl });
  // Retrocompatibilità: i vecchi blocchi salvavano gli elementi in `subblocks`
  const formData = data.items
    ? data
    : { ...data, items: (data.subblocks || []).map(toItem) };

  return (
    <>
      <View data={formData} id={block} isEditMode={true} />
      <SidebarPortal selected={selected}>
        <BlockDataForm
          schema={schema}
          title={schema.title}
          onChangeField={(id, value) => {
            const { subblocks, ...rest } = formData;
            onChangeBlock(block, {
              ...rest,
              [id]: value,
            });
          }}
          formData={formData}
          block={block}
        />
      </SidebarPortal>
    </>
  );
};

Edit.propTypes = {
  selected: PropTypes.bool.isRequired,
  block: PropTypes.string.isRequired,
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  onChangeBlock: PropTypes.func.isRequired,
};

export default Edit;
